import { ROUTES } from '@/components/Shared/routes/routes';

export const INNER_PAGES = [
  ROUTES.autoCreditCreate,
  ROUTES.insurancesCreate,
  ROUTES.insurancesRequest(),
  ROUTES.client(),
  ROUTES.leadsUpdate()
];
